const _temp0 = require("./arrow-left.svg");
const _temp1 = require("./chatgpt.svg");
const _temp2 = require("./edit-04.svg");
const _temp3 = require("./file-md.svg");
const _temp4 = require("./file-pdf.svg");
const _temp5 = require("./menu_aichat.svg");
const _temp6 = require("./menu_benchmark.svg");
const _temp7 = require("./menu_case_files.svg");
const _temp8 = require("./menu_dashboard.svg");
const _temp9 = require("./menu_deal_details.svg");
const _temp10 = require("./menu_flowise_debug.svg");
const _temp11 = require("./menu_narrative_a1.svg");
const _temp12 = require("./menu_outputs.svg");
const _temp13 = require("./menu_score_details.svg");
const _temp14 = require("./menu_workstreams.svg");
const _temp15 = require("./plus.svg");
const _temp16 = require("./send-03.svg");
const _temp17 = require("./sparkle.svg");
const _temp18 = require("./task-checkmark.svg");
const _temp19 = require("./task-circle.svg");
const _temp20 = require("./task-locked.svg");
const _temp21 = require("./task-paused.svg");
const _temp22 = require("./task-working.svg");
const _temp23 = require("./x-close.svg");
module.exports = {
  "arrow-left": _temp0,
  "chatgpt": _temp1,
  "edit-04": _temp2,
  "file-md": _temp3,
  "file-pdf": _temp4,
  "menu_aichat": _temp5,
  "menu_benchmark": _temp6,
  "menu_case_files": _temp7,
  "menu_dashboard": _temp8,
  "menu_deal_details": _temp9,
  "menu_flowise_debug": _temp10,
  "menu_narrative_a1": _temp11,
  "menu_outputs": _temp12,
  "menu_score_details": _temp13,
  "menu_workstreams": _temp14,
  "plus": _temp15,
  "send-03": _temp16,
  "sparkle": _temp17,
  "task-checkmark": _temp18,
  "task-circle": _temp19,
  "task-locked": _temp20,
  "task-paused": _temp21,
  "task-working": _temp22,
  "x-close": _temp23
}